import type { GetVerificationsQuery } from 'src/types/graphql';

export type ProfileVerifications = NonNullable<
  GetVerificationsQuery['viewer']
>['profileVerifications'];

// Nudge types:
type VerificationsOpenDetailsNudge = Extract<
  NonNullable<ProfileVerifications>['nudge'],
  { __typename: 'VerificationsOpenDetailsNudge' }
>;

// Only includes 2 supported nudge credential types:
export type VerificationsNudgeVerifiableCredential = Exclude<
  Extract<
    NonNullable<ProfileVerifications>['nudge'],
    { __typename: 'VerifiableCredentialNudge2' }
  >['credential'],
  { __typename: 'LicenceVerifiableCredential' }
>;

export type VerificationsNudge =
  | VerificationsOpenDetailsNudge
  | {
      __typename: 'VerifiableCredentialNudge2';
      credential: VerificationsNudgeVerifiableCredential;
    };

export type VerifiableNudgeCredentialTypename =
  VerificationsNudgeVerifiableCredential['__typename'];

// Verifiable Credential types:
export type Verified = NonNullable<
  NonNullable<ProfileVerifications>['verified']
>;

export type Verifiable = NonNullable<
  NonNullable<ProfileVerifications>['verifiable']
>;

export type VerifiableCredential = NonNullable<
  Verifiable[number]['credentials']
>[number];

export type VerifiableCredentialTypename = VerifiableCredential['__typename'];

export const supportedVerifiableCredentialTypenames = new Set([
  'IdentityVerifiableCredential',
  'WorkplaceVerifiableCredential',
  'LicenceVerifiableCredential',
]);
